import format from 'date-fns/format';
import { toaster } from 'evergreen-ui';
import html2canvas from 'html2canvas';
import PdfConverter from 'jspdf';

/**
 *
 * TODO: переделать на универсальную функцию создания PDF
 */
const DATE_FORMAT_API = 'yyyy.MM.dd HH:mm:ss';

export default async function PDFGraphsCreator(
  date, station, datasource, name
) {
  const inputs = document.querySelectorAll("canvas");
  // описание формата документа (ориентация, измерение, формат)
  const pdf = new PdfConverter('l', 'mm', 'a4');

  // создание pdf страниц
  const promises = Array.from(inputs).map((input, index) => html2canvas(input).then((canvas) => {
    /**
     * Здесь делаем canvas для доп инфы, так как jsPdf не поддерживает кириллицу((
     */
    const additionalInfoCanvas = document.createElement('canvas'); // доп инфа
    additionalInfoCanvas.width = 1000;
    additionalInfoCanvas.height = 300;

    const ctx = additionalInfoCanvas.getContext('2d');
    ctx.font = '18px oblique';
    ctx.fillText(
      `${format(
          new Date(date.startDate), 
          DATE_FORMAT_API
      )} - ${format(
          new Date(date.endDate), 
          DATE_FORMAT_API
      )}`,
      10,
      15
    ); // дата

    if (station) ctx.fillText(`Станция: ${station?.name}`, 10, 40);
    if (datasource) {
      ctx.fillText(`Станция: ${station?.name}`, 10, 40);
      ctx.fillText(`Источник: ${datasource?.datasourceType?.fullName}`, 10, 65);
    }

    const imgCanvas = canvas.toDataURL('image/png', 1.0);
    const imgAddInfoCanvas = additionalInfoCanvas.toDataURL('image/png', 1.0);

    pdf.addImage(
      imgAddInfoCanvas,
      'png',
      10,
      10,
    );
    pdf.addImage(
      imgCanvas,
      'png',
      10,
      30,
      280,
      150,
    );
    // че то он мудрит с индексом 0
    if (index !== inputs.length - 1) pdf.addPage();
  }));

  // html2canvas работает асинхронно

  Promise.all(
    await promises,
  ).then(() => {
    pdf.save(name);
  }).catch((err) => {
    console.log(err);
    toaster.danger('Ошибка при создании PDF!');
  });
}
